'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiWine = function TiWine(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.3 15.7c0-4.2-1.5-9.3-1.6-9.5-0.2-0.7-0.9-1.2-1.6-1.2h-12.2c-0.7 0-1.4 0.5-1.6 1.2-0.1 0.2-1.6 5.3-1.6 9.5 0 4.6 3.3 8.4 7.7 9.1 0 0.1-0.1 0.1-0.1 0.2v6.7h-1.6c-1 0-1.7 0.7-1.7 1.6s0.7 1.7 1.7 1.7h6.6c1 0 1.7-0.7 1.7-1.7s-0.7-1.6-1.7-1.6h-1.6v-6.7c0-0.1-0.1-0.1-0.1-0.2 4.4-0.7 7.7-4.5 7.7-9.1z m-9.3 6c-3 0-5.4-2.2-5.9-5h11.8c-0.5 2.8-2.9 5-5.9 5z m-5.9-6.7c0.1-2.4 0.7-5.2 1.1-6.7h9.6c0.4 1.5 1 4.3 1.1 6.7h-11.8z' })
        )
    );
};

exports.default = TiWine;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/wine.js
// module id = 3811
// module chunks = 0